import { createContext, useState, useEffect } from "react";
import i18n from "i18next";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState("en");

  // Load the language from localStorage or default to "en"
  useEffect(() => {
    const savedLanguage = localStorage.getItem("appLanguage") || "en";
    setCurrentLanguage(savedLanguage);
    i18n.changeLanguage(savedLanguage); // Ensure i18n syncs with the saved language
  }, []);

  const changeLanguage = (lang) => {
    setCurrentLanguage(lang);
    i18n.changeLanguage(lang); // Update i18n
    localStorage.setItem("appLanguage", lang); // Persist to localStorage
  };

  return (
    <LanguageContext.Provider
      value={{
        currentLanguage,
        changeLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
